import { render } from "./TestView.vue?vue&type=template&id=e13dc90e&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"

import "./TestView.vue?vue&type=style&index=0&id=e13dc90e&scoped=true&lang=css"
import "./TestView.vue?vue&type=style&index=1&id=e13dc90e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13dc90e"]])

export default __exports__